import { cn } from '@/lib/utils'

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-xl bg-[#f3efe6]/60 dark:bg-slate-800/60 shadow-sm',
        'before:absolute before:inset-0 before:-translate-x-full',
        'before:animate-skeleton-shimmer',
        'before:bg-gradient-to-r before:from-transparent before:via-white/40 dark:before:via-white/5 before:to-transparent',
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
